<template>
  <div class="wai">
    <div class="curd">
      <div class="add">
        <el-button round @click="add">添加部门</el-button>
      </div>
    </div>
    <div class="zhu">
      <el-table :data="list" style="width: 100%">
        <el-table-column prop="id" label="id" />
        <el-table-column prop="name" label="部门名称" />
        <el-table-column prop="create_time" label="创建时间" />
        <el-table-column prop="update_time" label="修改时间" />
        <el-table-column label="操作">
          <template #default="{ row }">
            <el-button type="primary" @click="upd(row)" size="small">修改</el-button>
            <el-button type="primary" @click="del(row)" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog @close="dialogclose()" v-model="dialog" width="400" :close-on-click-modal="false">
      <div class="adddig">
        <div v-if="curdtype == 1">
          <div class="group">
            <div class="lab">
              部门名称
            </div>
            <div class="inp">
              <el-input v-model="departmentname" style="width: 240px" placeholder="请输入部门名称" />
            </div>
          </div>
          <div style="text-align: center;">
            <el-button style="width: 300px;" @click="addbumen()">添加部门</el-button>
          </div>
        </div>
        <div v-if="curdtype == 2">
          <div class="group">
            <div class="lab">
              原部门名称
            </div>
            <div class="inp">
              <el-input disabled v-model="dname" style="width: 240px" />
            </div>
          </div>
          <div class="group">
            <div class="lab">
              新部门名称
            </div>
            <div class="inp">
              <el-input v-model="departmentname" style="width: 240px" placeholder="请输入新部门名称" />
            </div>
          </div>
          <div style="text-align: center;">
            <el-button style="width: 300px;" @click="updatebumen()">修改部门</el-button>
          </div>
        </div>
        <div v-if="curdtype == 3">
          <div class="group">
            <div class="lab">
              是否确定删除
            </div>
            <div class="inp">
              <el-input disabled v-model="dname" style="width: 240px" />
            </div>
          </div>
          <div style="display: flex;justify-content: center;">
            <el-button style="width: 150px;" type="info" @click="dialog = false">取消</el-button>
            <el-button style="width: 150px;" type="danger" @click="delbumen()">确认删除</el-button>
          </div>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script setup>
  import {
    ElMessage
  } from 'element-plus';
  import {
    onMounted,
    reactive,
    ref
  } from 'vue';
  import {
    adddepartment,
    deldepartment,
    getdepartmentlist,
    upddepartment
  } from '@/api/api'
  onMounted(() => {
    getlist()
  })
  //弹窗
  const dialog = ref(false)
  //部门名
  const departmentname = ref()
  const curdtype = ref(1)
  //修改参数
  const did = ref()
  const dname = ref()

  const list = ref()
  const getlist = async () => {
    const res = await getdepartmentlist()
    if (res.code == 200) {
      list.value = res.data.list
    } else {
      ElMessage.error(res.message)
    }
  }
  const addbumen = async () => {
    if(departmentname.value == "" || departmentname.value == null){
      ElMessage.error("部门不能为空！")
      return
    }
    const data = {
      name: departmentname.value
    }
    const res = await adddepartment(data)
    if (res.code == 200) {
      ElMessage.success("部门添加成功")
    } else {
      ElMessage.error(res.message)
    }
    getlist()
    dialog.value = false
  }
  const updatebumen = async () => {
    if(departmentname.value == "" || departmentname.value == null){
      ElMessage.error("新部门不能为空！")
      return
    }
    const data = {
      department_id: did.value,
      department_name: departmentname.value
    }
    const res = await upddepartment(data)
    if (res.code == 200) {
      ElMessage.success("部门名称修改成功")
    } else {
      ElMessage.error(res.message)
    }
    getlist()
    dialog.value = false
  }
  const delbumen = async () => {
    const data = {
      department_id: did.value
    }
    const res = await deldepartment(data)
    if (res.code == 200) {
      ElMessage.success("部门删除成功")
    } else {
      ElMessage.error(res.message)
    }
    getlist()
    dialog.value = false
  }

  const add = () => {
    curdtype.value = 1
    dialog.value = true
  }
  const upd = (row) => {
    did.value = row.id
    dname.value = row.name
    curdtype.value = 2
    dialog.value = true
  }
  const del = (row) => {
    did.value = row.id
    dname.value = row.name
    curdtype.value = 3
    dialog.value = true
  }
  const dialogclose = () => {
    curdtype.value = 1
    departmentname.value = ''
    did.value = ''
    dname.value = ''
  }
</script>

<style lang="scss" scoped>
  .wai {
    width: 100%;
    height: 100%;
    padding: 0 20px;

    .curd {
      height: 50px;
      width: 100%;
      display: flex;
      justify-content: space-between;
    }

    .zhu {
      width: 100%;
      height: calc(100% - 45px - 50px);
      overflow-y: auto;
      border-radius: 10px;

      .biao {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;

        .tou {
          font-weight: bolder;
          color: #000;
          height: 40px;
          background-color: #dddddd;
        }

        .shen {
          height: 40px;
          color: #000;
          text-align: center;
          font-size: 16px;
        }

        .shen:nth-child(odd) {
          background-color: #F5F7FA;
        }
      }
    }

    .page {
      height: 45px;
      width: 100%;
      display: flex;
      padding: 0 30px;
      justify-content: right;
    }
  }

  .adddig {
    .group {
      width: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      padding: 10px 0px;

      .lab {
        padding-left: 20px;
        width: 130px;
      }
    }
  }
</style>
